export default {
  welcomes:'Chào mừng bạn đến với phần phụ trợ, vui lòng chọn các thanh menu khác ở bên trái',
  rules: {
    username: 'tài khoản không được bỏ trống！',
    password: 'mật khẩu không được bỏ trống！',
    code: 'mã xác nhận không được bỏ trống！'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/login.js